import BorderAllIcon from "@mui/icons-material/BorderAll";
import BooleanButtons from "../../../components/shared/BooleanButtons";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import { LIST_VIEW } from "../../../constants";
import { OwcListItem, OwcSelectDropdown } from '@one/react';
import styled from 'styled-components';

const MainComponentStyled = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  margin-right: 8px;
`;

const BookingViewChanger = ({ setTempRowData, myBookingsView, view, setView, isEquipmentView, setIsEquipmentView, setListGroupByView, listGroupByView, isToggle = false }) => {
  const handleView = (view) => {
    setView(view);
  };
  const handleEquipmentView = (equipmentView) => {
    setIsEquipmentView(equipmentView);
  }

  return (
    <MainComponentStyled >
      {(!(myBookingsView && view !== LIST_VIEW) && view === LIST_VIEW) && (<OwcSelectDropdown
        label="Grouped by"
        style={{ width: 160, marginRight: 16, marginBottom: 10 }}
        onSelectChange={(e) => {
          if (setTempRowData) {
            setTempRowData([]);
          }
          const idx = e.detail[0];
          const groupByType = idx === 0 ? 'BOOKING' : 'NONE'
          setListGroupByView && setListGroupByView(groupByType);
          if (view !== LIST_VIEW) {
            handleEquipmentView(groupByType === 'NONE')
          }
        }}
      >
        <OwcListItem value="BOOKING" selected={listGroupByView === 'BOOKING'}>
          Booking
        </OwcListItem>
        <OwcListItem value="NONE" selected={listGroupByView === 'NONE'}>
          None
        </OwcListItem>
      </OwcSelectDropdown>)}
      <BooleanButtons
        trueProps={{
          "data-testid": "button-for-booking-grid-view",
        }}
        falseProps={{
          "data-testid": "button-for-booking-list-view",
        }}
        value={view}
        trueLabel={<FormatListBulletedIcon />}
        falseLabel={<BorderAllIcon />}
        onChange={handleView}
        color="primary"
        myBookingsView={myBookingsView}
      />
    </MainComponentStyled>
  );
};
export default BookingViewChanger;
